// The subscription lockout's shared words. authStore.subscriptionLockedOut holds a sentence; this
// is the one the store sets itself while the owner is still choosing who stays on the free plan
// (`pendingUserSelection`), so the locked-out screen can tell that case from a downgrade.
// Kept apart from stores/auth.ts (which re-exports it) so pure modules can use it without Pinia.

export const PENDING_SELECTION_MESSAGE =
  'Your organization owner needs to confirm the active user list. Please try again shortly.'
